/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const physicalInfrastructureEnumsFaultTypeOptionEnum = {
    Overload: 'Overload',
    ShortCircuit: 'ShortCircuit',
    BreakerTrip: 'BreakerTrip',
    Other: 'Other',
} as const;

export type PhysicalInfrastructureEnumsFaultTypeOptionEnumKey =
    (typeof physicalInfrastructureEnumsFaultTypeOptionEnum)[keyof typeof physicalInfrastructureEnumsFaultTypeOptionEnum];

export type PhysicalInfrastructureEnumsFaultTypeOption = PhysicalInfrastructureEnumsFaultTypeOptionEnumKey;
